import React from 'react';

export default function FullRoundedButton({ onClick, className, children }) {
  return (
    <button onClick={onClick} className={`btn btn-rounded ${className}`}>
      {children}
    </button>
  );
}
